module.exports = __webpack_public_path__ + "static/media/73.44c43b27.jpg";